import { OrderStatus } from "@deliverr/business-types";

const formatCost = (cost: number | undefined, status: OrderStatus): number | undefined => {
  return cost && status !== OrderStatus.CANCELLED ? cost : 0;
};

export default formatCost;
